export enum TechnologyEnum {
  COATINGS,
  WELDING,
  PIPES,
  VALVES,
}
